import { MOBILE_LAYOUT } from '../../utils/mobileView';
import { buildMobileInputZoomFixOverrides } from './mobileInputZoomFix';

/** MUI overrides applied in Capacitor iOS/Android for touch-first UI. */
export function buildMobileThemeOverrides(accentColor = '#4ce1b6') {
  const touch = `${MOBILE_LAYOUT.touchMinHeight}px`;

  return {
    typography: {
      h4: { fontSize: '1.35rem', fontWeight: 600 },
      h5: { fontSize: '1.15rem', fontWeight: 600 },
      h6: { fontSize: '1rem', fontWeight: 600 },
      body1: { fontSize: '0.95rem' },
      button: { fontSize: '0.875rem', textTransform: 'none' },
    },
    components: {
      ...buildMobileInputZoomFixOverrides(),
      MuiButton: {
        styleOverrides: {
          root: {
            minHeight: touch,
            borderRadius: 10,
            textTransform: 'none',
            fontWeight: 600,
            paddingLeft: 16,
            paddingRight: 16,
          },
          sizeLarge: {
            minHeight: 48,
            fontSize: '1rem',
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            width: touch,
            height: touch,
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          size: 'medium',
        },
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': {
              minHeight: touch,
              borderRadius: 10,
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: 12,
          },
        },
      },
      MuiDialog: {
        defaultProps: {
          fullScreen: true,
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: '10px 8px',
            fontSize: '0.8125rem',
          },
        },
      },
    },
  };
}
